import { render, staticRenderFns } from "./TableCellTypeDateDate.vue?vue&type=template&id=2e2c13a9&scoped=true"
import script from "./TableCellTypeDateDate.vue?vue&type=script&lang=js"
export * from "./TableCellTypeDateDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2c13a9",
  null
  
)

export default component.exports